<template>
    <div v-if="pagination && meta" class="flex items-center justify-end font-heading font-light text-right">
            <span v-if="0 === meta.total">No Bricks</span>
            <span v-if="1 < meta.total">Bricks <span v-text="meta.from.toLocaleString()"></span>-<span v-text="meta.to.toLocaleString()"></span> of <span v-text="meta.total.toLocaleString()"></span></span>
    </div>
</template>


<script>
    export default {
        props: {
            pagination: {
                type: Object,
                required: false,
                default() {
                    return null;
                },
            }
        },

        computed: {
            meta() {
                if (null === this.pagination || 0 === this.pagination.meta.total) {
                    return null;
                }

                return this.pagination.meta;
            },
        },
    };
</script>
